import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../services/api/axios.config";
import { notify } from "../utils/methods/notification";

const initialState = {
  programCodeList: {},
  isLoading: false
};

// For Fetching Approved LSM Listing
export const getProgramCodeList = createAsyncThunk(
  "bmr/program-code/list",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.post(`/program-code/list`, filters);
      return  response.data;
    } catch (error) {
     notify.error(
          error || error.message || error.response || error.response.data
        )
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// For Creating COA Form
export const createProgramCode = createAsyncThunk(
  "bmr/program-code/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(`/program-code/create`, formData);
      notify.success(response?.data?.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateProgramCode = createAsyncThunk(
  "bmr/program-code/update", // Fixed: match slice name
  async (args, { rejectWithValue }) => {
    try {
      const { formData,id } = args
      const response = await api.put(`/program-code/${id}/update`, formData);
     notify.success(response?.data?.message)
      return response.data;
    } catch (error) {
     notify.error(error?.response?.data || error?.message || error)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// For QC Approval of COA Form
export const deleteProgramCode = createAsyncThunk(
  "bmr/program-code/delete", // Fixed: match slice name
  async (args, { rejectWithValue }) => {
    try {
      const { id } = args
      const response = await api.delete(`/program-code/delete/${id}`);
      return response.data;
    } catch (error) {
     notify.error(error?.response?.data || error?.message || error)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


const programSlice = createSlice({
  name: "programCodeSlice",
  initialState,
  reducers: {
  },
  extraReducers: (builder) =>
    builder
      // Handling the state case for the LSM Approved listing
      .addCase(getProgramCodeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProgramCodeList.fulfilled, (state, action) => {
        // Structure the data to match what the component expects
        state.programCodeList = {
          items: action.payload?.data ?? [],
          pageDetails: action.payload?.page_details ?? {
            no_of_records: 0,
            page: 1,
            per_page: 10
          }
        };
        state.isLoading = false;
      })
      .addCase(getProgramCodeList.rejected, (state) => {
        state.isLoading = false;
      })
});

export const selectPCIsLoading = (state) => state.programCodeSlice.isLoading;

export const selectProgramCodeList = (state) => state.programCodeSlice.programCodeList;

export default programSlice.reducer;